import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import Quote, { QuoteProps } from "./Quote";

import akadam from "./akadam.jpg";
import lnicholls from "./lnicholls.jpg";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        display: "flex",
        backgroundColor: "#fafafa",
        paddingTop: theme.spacing.unit * 4,
        paddingBottom: theme.spacing.unit * 4,
        [theme.breakpoints.down("md")]: {
            width: "100%",
            flexDirection: "column"
        }
    }
});

interface QuotesProps {
    noop?: string
}

const quotes: QuoteProps[] = [
    {
        quote: "The code is as beautiful as the templates themselves",
        handle: "Louis Nicholls",
        position: "Founder @PostPerk",
        avatar: lnicholls
    },
    {
        quote: "Learned a lot from those kits. Now I make my own beautiful apps.",
        handle: "Akshay Kadam",
        position: "Student",
        avatar: akadam
    }
];

class Quotes extends React.Component<WithStyles<ClassNames> & QuotesProps> {
    public render() {
        const {classes} = this.props;
        return (
            <div className={classes.container}>
                {quotes.map(quote => <Quote key={quote.handle} {...quote} />)}
            </div>
        );
    }
}

export default withStyles(styles)(Quotes);



// WEBPACK FOOTER //
// ./src/components/quotes/Quotes.tsx